function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "12.001",
  cy: "8.63",
  r: "1.501",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15"
}), /*#__PURE__*/React.createElement("rect", {
  width: "13.506",
  height: "13.506",
  x: "2.247",
  y: "2.248",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  rx: "3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "6.749",
  cy: "8.255",
  r: "1.876",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M10.876 15.753v-.75a2.626 2.626 0 00-2.626-2.626H5.29a2.62 2.62 0 00-2.548 2.02m9.259-2.016h1.13a2.603 2.603 0 012.377 1.557"
}));